// AppInit.tsx
import { useEffect } from 'react';
import { useGetAllWarehousesQuery } from 'services/warehouse.service';
import { useWarehouseContext } from 'stores/warehouseContext';

export const AppInit = () => {
  const { setWarehouses } = useWarehouseContext();

  const { data, isSuccess } = useGetAllWarehousesQuery({
    query: { page: 1, limit: 100 },
  });

  useEffect(() => {
    if (isSuccess && data?.data?.rows) {
      setWarehouses(data.data.rows);
    }
  }, [isSuccess, data, setWarehouses]);

  return null;
};
